import { render, staticRenderFns } from "./BlogSubcategories.vue?vue&type=template&id=04ea8d3a&"
import script from "./BlogSubcategories.vue?vue&type=script&lang=js&"
export * from "./BlogSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports